








































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import AlertNotification from '@/modules/notification/components/panel/AlertNotification.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import QForm from 'quasar/src/components/form/QForm.js';
import { PanelContentCampaignService } from '@/modules/content-campaign/services/panel-content-campaign.service'
import {
  ContentCampaignResourceModel,
  ContentCampaignResourceType
} from '@/modules/content-campaign/models/content-campaign-resource.model'
import BaseTooltip from '@/modules/shared/components/shared/kit/BaseTooltip.vue'

@Component({
  inheritAttrs: false,
  components: { BaseButton, AlertNotification, BaseInput, Modal, BaseTooltip }
})
export default class PanelContentCampaignEditModal extends Vue {
  constructor(
    private readonly service: PanelContentCampaignService
  ) {
    super()
  }

  $refs!: {
    form: QForm
  }

  @Prop({ required: true }) contentCampaign: ContentCampaignResourceType
  private campaignEditModal = false
  private campaignEditModalLoading = false

  private model: Partial<ContentCampaignResourceModel> = {
    title: this.contentCampaign.data.title
  }

  async onSubmit() {
    const ok = await this.$refs.form.validate()
    if (ok) {
      this.campaignEditModalLoading = true
      this.service.updateCampaignDetail(this.contentCampaign.data.id, this.model)
    }
  }
}
